import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// @material-ui/core components

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import View from "./View";
import ViewDetailList from "./ViewDetailList";

import { bookingApi } from "functions/apis";

export default function Detail(props) {
  const source = useRef(new AbortController());
  const { id } = useParams();
  const [agentBookingTransfer, setAgentBookingTransfer] = React.useState(null);

  useEffect(() => {
    bookingApi
      .get("/AgentBookingTransfers/" + id, {
        signal: source.current.signal
      })
      .then(data => setAgentBookingTransfer(data))
      .catch(error => console.log(error));
    return () => source.current.abort();
  }, [id]);

  return (
    agentBookingTransfer !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <View
            agentBookingTransfer={agentBookingTransfer}
            history={props.history}
          />
          <ViewDetailList agentBookingTransfer={agentBookingTransfer} />
        </GridItem>
      </GridContainer>
    )
  );
}

Detail.propTypes = {
  history: PropTypes.object
};
